<ng-container *ngIf="isOrgAdminPortal">
  <app-header [forceLightBackground]="true"></app-header>
</ng-container>
<div [class.org-admin-manage-contributions]="isOrgAdminPortal" [class.provider-manage-contributions-embed-root]="isProviderPortal">
  <div [class.org-admin-manage-contributions--layout]="isOrgAdminPortal" [class.provider-manage-contributions-embed-root--layout]="isProviderPortal">
    <app-org-admin-sidebar *ngIf="isOrgAdminPortal" class="org-admin-manage-contributions--sidebar"></app-org-admin-sidebar>
    <div [class.org-admin-manage-contributions--content]="isOrgAdminPortal" [class.provider-manage-contributions-embed-root--inner]="isProviderPortal">
      <app-page-header *ngIf="isOrgAdminPortal"></app-page-header>
      <div class="manage-contributions-container">
        <!-- Filter Panel -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="contributionsData"
          [pagination]="pagination"
          [loading]="loading"
          [emptyMessage]="emptyMessage"
          [initialSortColumn]="initialSortColumn"
          [initialSortDirection]="initialSortDirection"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Permission Column (icon + content like dataset collection) -->
          <ng-template #permissionCell let-row>
            <div [ngClass]="getPermissionBadgeClass(row.permission)">
              <img
                *ngIf="row.permission && row.permission.toUpperCase() === 'RESTRICTED'"
                src="/filters/lock.svg"
                alt="Restricted"
                class="permission-badge-icon"
              />
              <img
                *ngIf="row.permission && (row.permission.toUpperCase() === 'OPEN' || row.permission.toUpperCase() === 'PUBLIC')"
                src="/filters/globe.svg"
                alt="Public"
                class="permission-badge-icon"
              />
              <img
                *ngIf="row.permission && row.permission.toUpperCase() === 'PRIVATE'"
                src="/filters/lock.svg"
                alt="Private"
                class="permission-badge-icon"
              />
              <span>{{ getPermissionLabel(row.permission) }}</span>
            </div>
          </ng-template>

          <!-- Resource Server: icon + label (same glyphs as dataset onboarding cards) -->
          <ng-template #resourceServerCell let-row>
            <div
              class="resource-server-cell"
              [attr.data-rs-variant]="shouldShowResourceServerIcon(row) ? getResourceServerIconType(row.resourceServer) : null"
            >
              @if (shouldShowResourceServerIcon(row)) {
              <span class="resource-server-cell__icon-box" aria-hidden="true">
                @switch (getResourceServerIconType(row.resourceServer)) {
                  @case ('network') {
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="6" cy="12" r="2.5" stroke="currentColor" stroke-width="1.5"/>
                      <circle cx="18" cy="6" r="2.5" stroke="currentColor" stroke-width="1.5"/>
                      <circle cx="18" cy="18" r="2.5" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M8.2 11.2l7.1-3.4M8.2 12.8l7.1 3.4M15.5 8.5v7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  }
                  @case ('globe') {
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M3 12h18M12 3c2.5 2.8 2.5 14.2 0 18M12 3c-2.5 2.8-2.5 14.2 0 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  }
                  @case ('files') {
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path d="M14 2V8H20M12 18V12M9 15H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  }
                  @case ('server') {
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5" y="5" width="14" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
                      <rect x="5" y="13" width="14" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
                      <circle cx="8" cy="8" r="0.75" fill="currentColor"/>
                      <circle cx="8" cy="16" r="0.75" fill="currentColor"/>
                    </svg>
                  }
                }
              </span>
              }
              <span class="resource-server-cell__label">{{ getResourceServerDisplayLabel(row) }}</span>
            </div>
          </ng-template>

          <!-- Custom Published On Column (DD-MMM-YYYY HH:MM IST; time in grey, smaller font) -->
          <ng-template #publishedOnCell let-row>
            <span>{{ getPublishedOnDatePart(row.publishedOn) }}</span>
            <span class="published-on-time">{{ getPublishedOnTimePart(row.publishedOn) }}</span>
          </ng-template>

          <!-- Provider / org-admin Manage Assets: publish status (Pending, Active, Rejected) -->
          <ng-template #statusCell let-row>
            <span class="asset-status-cell">
              <span [ngClass]="getStatusChipClassForRow(row)">{{ getStatusLabelForRow(row) }}</span>
              <span
                *ngIf="shouldShowSftpApiPendingApprovalHint(row) || shouldShowUploadLaterPendingInfoIcon(row)"
                class="asset-status-info-icon asset-status-info-icon--pending"
                [attr.title]="getSftpApiPendingApprovalHintTooltip(row)"
                [attr.aria-label]="getSftpApiPendingApprovalHintTooltip(row)"
                role="img"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75"/>
                  <path d="M12 10v6M12 7h.01" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                </svg>
              </span>
              <span
                *ngIf="shouldShowSftpApiRejectedInfoIcon(row) || isOrgAdminPublishRejected(row)"
                class="asset-status-info-icon asset-status-info-icon--rejected"
                [attr.title]="getSftpApiRejectedInfoTooltip(row)"
                [attr.aria-label]="getSftpApiRejectedInfoTooltip(row)"
                role="img"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75"/>
                  <path d="M12 10v6M12 7h.01" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                </svg>
              </span>
            </span>
          </ng-template>

          <!-- Custom Action Column (dropdown rendered in fixed overlay below) -->
          <ng-template #actionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn action-btn--primary" 
                type="button"
                appActionDropdownTrigger
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
              >
                <span class="action-btn-label">Action</span>
                <svg class="action-btn-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
            </div>
          </ng-template>
        </app-table>
      </div>

      <!-- View Files modal cell templates (outside tab *ngIf so ViewChild resolves). -->
      <ng-template #viewFilesActionsCell let-row>
        <div
          class="view-files-action-cell-wrapper action-cell-wrapper"
          [class.action-dropdown-open]="isViewFilesActionDropdownOpen(row)"
        >
          <button
            type="button"
            class="action-btn action-btn--primary"
            appActionDropdownTrigger
            [class.active]="isViewFilesActionDropdownOpen(row)"
            (click)="toggleViewFilesActionDropdown($event, row)"
          >
            <span class="action-btn-label">Action</span>
            <svg class="action-btn-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
        </div>
      </ng-template>

      <!-- Fixed overlay: dropdown on top of table -->
      <div
        *ngIf="overlayPosition && openDropdownRow"
        class="action-dropdown-overlay"
        role="menu"
        aria-label="Asset actions"
        [class.action-dropdown-overlay--above]="overlayPosition.openAbove"
        [style.top.px]="overlayPosition.top"
        [style.left.px]="overlayPosition.left"
        [style.right.px]="overlayPosition.right"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item">
            <button type="button" role="menuitem" class="dropdown-link" (click)="$event.stopPropagation(); handleAction('view', openDropdownRow)">View</button>
          </li>
          <li class="dropdown-item" *ngIf="openDropdownRow && canViewFeedback(openDropdownRow)">
            <button type="button" role="menuitem" class="dropdown-link" (click)="$event.stopPropagation(); handleAction('view-feedback', openDropdownRow)">View Feedback</button>
          </li>
          <ng-container *ngIf="openDropdownRow && !isAssetRejected(openDropdownRow)">
            <li class="dropdown-item">
              <button
                type="button"
                role="menuitem"
                class="dropdown-link"
                [class.dropdown-link--disabled]="isModifyAssetDisabled(openDropdownRow)"
                [disabled]="isModifyAssetDisabled(openDropdownRow)"
                [attr.title]="getModifyAssetDisabledTooltip(openDropdownRow)"
                [attr.aria-disabled]="isModifyAssetDisabled(openDropdownRow)"
                (click)="$event.stopPropagation(); handleAction('modify', openDropdownRow)"
              >
                Modify Asset
              </button>
            </li>
            <li class="dropdown-item" *ngIf="canViewFiles(openDropdownRow)">
              <button type="button" role="menuitem" class="dropdown-link" (click)="$event.stopPropagation(); handleAction('view-files', openDropdownRow)">
                View Files
              </button>
            </li>
            <li class="dropdown-item" *ngIf="canShowOnboardingStyleUploadModalAction(openDropdownRow)">
              <button
                type="button"
                role="menuitem"
                class="dropdown-link"
                (click)="$event.stopPropagation(); handleAction('ngsild-upload-modal', openDropdownRow)"
              >
                {{ getOnboardingStyleUploadActionLabel(openDropdownRow) }}
              </button>
            </li>
            <li class="dropdown-item" *ngIf="canShowOgcFeatureUploadAction(openDropdownRow)">
              <div
                class="dropdown-item-tooltip-wrap"
                [attr.title]="getOgcUploadActionDisabledTooltip(openDropdownRow)"
              >
                <button
                  type="button"
                  role="menuitem"
                  class="dropdown-link"
                  [class.dropdown-link--disabled]="isOgcUploadActionDisabled(openDropdownRow)"
                  [disabled]="isOgcUploadActionDisabled(openDropdownRow)"
                  [attr.aria-disabled]="isOgcUploadActionDisabled(openDropdownRow)"
                  (click)="$event.stopPropagation(); handleAction('ogc-upload-modal', openDropdownRow)"
                >
                  Upload Files
                </button>
              </div>
            </li>
            <li class="dropdown-item" *ngIf="canShowOgcRasterEditStacAction(openDropdownRow)">
              <button
                type="button"
                role="menuitem"
                class="dropdown-link"
                [class.dropdown-link--disabled]="isOgcUploadActionDisabled(openDropdownRow)"
                [disabled]="isOgcUploadActionDisabled(openDropdownRow)"
                [attr.title]="isOgcUploadActionDisabled(openDropdownRow) ? 'Unavailable while publish status is Pending' : null"
                [attr.aria-disabled]="isOgcUploadActionDisabled(openDropdownRow)"
                (click)="$event.stopPropagation(); handleAction('stac-edit', openDropdownRow)"
              >
                Edit STAC
              </button>
            </li>
            <li class="dropdown-item" *ngIf="canShowUploadMoreAction(openDropdownRow)">
              <button
                type="button"
                role="menuitem"
                class="dropdown-link"
                [class.dropdown-link--disabled]="isUploadMoreFilesDisabled(openDropdownRow)"
                [disabled]="isUploadMoreFilesDisabled(openDropdownRow)"
                [attr.title]="isUploadMoreFilesDisabled(openDropdownRow) ? 'Unavailable while publish status is Pending' : null"
                [attr.aria-disabled]="isUploadMoreFilesDisabled(openDropdownRow)"
                (click)="$event.stopPropagation(); handleAction('upload-more')"
              >
                {{ getUploadMoreFilesActionLabel(openDropdownRow) }}
              </button>
            </li>
            <li class="dropdown-item">
              <button
                type="button"
                role="menuitem"
                class="dropdown-link"
                (click)="$event.stopPropagation(); handleAction('additional-info', openDropdownRow)"
              >
                {{ getAdditionalInfoActionLabel(openDropdownRow) }}
              </button>
            </li>
            <li class="dropdown-divider" aria-hidden="true"></li>
            <li class="dropdown-item">
              <button type="button" role="menuitem" class="dropdown-link dropdown-link--danger" (click)="$event.stopPropagation(); handleAction('delete', openDropdownRow)">Remove Asset</button>
            </li>
          </ng-container>
        </ul>
      </div>

      <!-- View Files modal: per-file Action menu (Download / Delete) -->
      <div
        *ngIf="viewFilesDropdownOverlayPosition && viewFilesDropdownRow"
        class="action-dropdown-overlay view-files-action-dropdown-overlay"
        role="menu"
        aria-label="File actions"
        [class.action-dropdown-overlay--above]="viewFilesDropdownOverlayPosition.openAbove"
        [style.top.px]="viewFilesDropdownOverlayPosition.top"
        [style.left.px]="viewFilesDropdownOverlayPosition.left"
        [style.right.px]="viewFilesDropdownOverlayPosition.right"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item">
            <button
              type="button"
              role="menuitem"
              class="dropdown-link"
              (click)="$event.stopPropagation(); onViewFilesOverlayDownload()"
            >
              Download
            </button>
          </li>
          <li class="dropdown-item">
            <button
              type="button"
              role="menuitem"
              class="dropdown-link dropdown-link--danger"
              (click)="$event.stopPropagation(); onViewFilesOverlayDelete()"
            >
              Delete
            </button>
          </li>
        </ul>
      </div>

      <!-- File upload modal (File resource server → View Files) -->
      <div
        *ngIf="showFileUploadModal && fileUploadModalRow"
        class="manage-file-upload-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="manage-file-upload-heading"
        (keydown)="$event.stopPropagation()"
      >
        <div
          class="manage-file-upload-modal__backdrop"
          aria-hidden="true"
          (click)="closeFileUploadModal()"
        ></div>
        <div
          class="manage-file-upload-modal__panel manage-file-upload-modal__panel--view-files"
          (click)="$event.stopPropagation()"
        >
          <header class="manage-file-upload-modal__header">
            <div class="manage-file-upload-modal__header-text">
              <h2 id="manage-file-upload-heading" class="manage-file-upload-modal__title">View Files</h2>
              <p class="manage-file-upload-modal__lede">
                Upload new files or view the list from the file server for this {{ getManageAssetsAssetKindLabel(fileUploadModalRow).toLowerCase() }}.
              </p>
              <p class="manage-file-upload-modal__subtitle" *ngIf="fileUploadModalRow.assetName">
                {{ getManageAssetsAssetKindLabel(fileUploadModalRow) }}: <strong>{{ fileUploadModalRow.assetName }}</strong>
              </p>
            </div>
            <button
              type="button"
              class="manage-file-upload-modal__close"
              (click)="closeFileUploadModal(); $event.stopPropagation()"
              aria-label="Close file upload dialog"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </header>
          <div class="manage-file-upload-modal__body">
            <div class="view-files-modal__tabs" role="tablist" aria-label="Dataset files">
              <button
                type="button"
                role="tab"
                class="view-files-modal__tab"
                [class.view-files-modal__tab--active]="viewFilesModalTab === 'files'"
                [attr.aria-selected]="viewFilesModalTab === 'files'"
                id="view-files-tab-files"
                aria-controls="view-files-panel-files"
                (click)="setViewFilesModalTab('files')"
              >
                <span class="view-files-modal__tab-icon" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span>View Files</span>
              </button>
              <button
                type="button"
                role="tab"
                class="view-files-modal__tab"
                [class.view-files-modal__tab--active]="viewFilesModalTab === 'upload'"
                [attr.aria-selected]="viewFilesModalTab === 'upload'"
                id="view-files-tab-upload"
                aria-controls="view-files-panel-upload"
                (click)="setViewFilesModalTab('upload')"
              >
                <span class="view-files-modal__tab-icon" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span>Upload Files</span>
              </button>
            </div>

            <div
              *ngIf="viewFilesModalTab === 'upload'"
              id="view-files-panel-upload"
              class="view-files-modal__panel"
              role="tabpanel"
              aria-labelledby="view-files-tab-upload"
            >
              <p class="view-files-modal__panel-lede">
                Drag and drop or browse to add files. Click <strong>Publish</strong> when uploads are complete.
              </p>
              <lib-ngsild-upload-files
                layout="modal"
                lockedUploadMethod="upload-file"
                [showModalPreviousButton]="false"
                [resourceServer]="getFileUploadModalResourceServer()"
                [fileFormat]="getFileUploadModalFileFormat()"
                [itemId]="getFileUploadModalItemId()"
                (modalDismiss)="closeFileUploadModal()"
                (publishSuccess)="onFileUploadPublishSuccess()"
              />
            </div>

            <div
              *ngIf="viewFilesModalTab === 'files'"
              id="view-files-panel-files"
              class="view-files-modal__panel view-files-modal__panel--list"
              role="tabpanel"
              aria-labelledby="view-files-tab-files"
            >
              <div class="view-files-table-wrap view-files-table-wrap--app-table">
                <p *ngIf="!viewFilesListLoading && viewFilesListError" class="view-files-table__error">
                  {{ viewFilesListError }}
                </p>
                <app-table
                  *ngIf="!viewFilesListError"
                  class="view-files-modal__app-table"
                  [columns]="viewFilesTableColumns"
                  [data]="viewFilesTableRows"
                  [loading]="viewFilesListLoading"
                  [pagination]="viewFilesTablePagination"
                  [dropdownOpenRowIndex]="viewFilesOpenDropdownRowIndex"
                  [emptyMessage]="'No files are listed for this dataset yet.'"
                  [skeletonRows]="6"
                  [scrollable]="false"
                  [bordered]="true"
                  [hoverable]="true"
                >
                </app-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- OGC Server: GeoPackage upload (same as dataset onboarding “Upload now”). -->
      <div
        *ngIf="showOgcUploadModal && ogcUploadModalRow"
        class="manage-file-upload-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="manage-ogc-upload-heading"
        aria-describedby="manage-ogc-upload-desc"
        (keydown)="$event.stopPropagation()"
      >
        <div
          class="manage-file-upload-modal__backdrop"
          aria-hidden="true"
          (click)="closeOgcUploadModal()"
        ></div>
        <div
          class="manage-file-upload-modal__panel manage-file-upload-modal__panel--ogc-upload"
          (click)="$event.stopPropagation()"
        >
          <header class="manage-file-upload-modal__header">
            <div class="manage-file-upload-modal__header-text">
              <h2 id="manage-ogc-upload-heading" class="manage-file-upload-modal__title">Upload Files</h2>
              <p id="manage-ogc-upload-desc" class="manage-file-upload-modal__lede">
                Upload GeoPackage files for this dataset.
              </p>
              <p class="manage-file-upload-modal__subtitle" *ngIf="ogcUploadModalRow?.assetName">
                Dataset: <strong>{{ ogcUploadModalRow.assetName }}</strong>
              </p>
            </div>
            <button
              type="button"
              class="manage-file-upload-modal__close"
              (click)="closeOgcUploadModal(); $event.stopPropagation()"
              aria-label="Close GeoPackage upload dialog"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </header>
          <div class="manage-file-upload-modal__body manage-file-upload-modal__body--ogc-upload">
            <div class="view-files-modal__panel view-files-modal__panel--ogc-upload">
              <p class="view-files-modal__panel-lede">
                Drag and drop or browse to add files. Click <strong>Publish</strong> when uploads are complete.
              </p>
            <lib-ogc-upload-files
              [loadKey]="ogcUploadLoadKey"
              [showModalPreviousButton]="false"
              [itemId]="getOgcUploadModalItemId()"
              [datasetTitle]="getOgcUploadModalDatasetTitle()"
              [datasetDescription]="getOgcUploadModalDatasetDescription()"
              (modalDismiss)="closeOgcUploadModal()"
              (publishSuccess)="onOgcUploadModalSuccess()"
              (uploadError)="onOgcUploadModalError($event)"
            />
            </div>
          </div>
        </div>
      </div>


      <!-- OGC Raster: STAC collection / item / asset onboarding modal. -->
      <div
        *ngIf="showStacOnboardingModal && stacOnboardingModalRow"
        class="manage-file-upload-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="manage-stac-onboarding-heading"
        (keydown)="$event.stopPropagation()"
      >
        <div
          class="manage-file-upload-modal__backdrop"
          aria-hidden="true"
          (click)="closeStacOnboardingModal()"
        ></div>
        <div
          class="manage-file-upload-modal__panel manage-file-upload-modal__panel--stac-onboarding"
          (click)="$event.stopPropagation()"
        >
          <header class="manage-file-upload-modal__header">
            <div class="manage-file-upload-modal__header-text">
              <h2 id="manage-stac-onboarding-heading" class="manage-file-upload-modal__title">Edit STAC</h2>
              <p class="manage-file-upload-modal__lede">
                @if (stacOnboardingCollectionExists) {
                  Manage STAC items and assets for this raster dataset.
                } @else {
                  Create a STAC collection for this raster dataset.
                }
                Dataset: <strong>{{ stacOnboardingModalRow?.assetName }}</strong>
              </p>
            </div>
            <button
              type="button"
              class="manage-file-upload-modal__close"
              (click)="closeStacOnboardingModal(); $event.stopPropagation()"
              aria-label="Close Edit STAC dialog"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </header>
          <div class="manage-file-upload-modal__body manage-file-upload-modal__body--stac-onboarding">
            <lib-stac-collection-onboarding
              [showModalPreviousButton]="false"
              [checkExistingCollection]="true"
              [itemId]="getStacOnboardingModalItemId()"
              [datasetTitle]="getStacOnboardingModalDatasetTitle()"
              [datasetDescription]="getStacOnboardingModalDatasetDescription()"
              (modalDismiss)="closeStacOnboardingModal()"
              (existingCollectionDetected)="onStacExistingCollectionDetected($event)"
              (onboardingSuccess)="onStacOnboardingModalSuccess($event)"
              (onboardingError)="onStacOnboardingModalError($event)"
              (onboardingWarning)="onStacOnboardingModalWarning($event)"
            />
          </div>
        </div>
      </div>
      <!-- NGSI-LD / Gateway: same onboarding “Add Data” flow (SFTP, API, gateway direct-push). -->
      <div
        *ngIf="showNgsildUploadModal && ngsildUploadModalRow"
        class="manage-file-upload-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="manage-ngsild-upload-heading"
        aria-describedby="manage-ngsild-upload-desc"
        (keydown)="$event.stopPropagation()"
      >
        <div
          class="manage-file-upload-modal__backdrop"
          aria-hidden="true"
          (click)="closeNgsildUploadModal()"
        ></div>
        <div
          class="manage-file-upload-modal__panel manage-file-upload-modal__panel--ngsild-upload"
          (click)="$event.stopPropagation()"
        >
          <header class="manage-file-upload-modal__header">
            <div class="manage-file-upload-modal__header-text">
              <h2 id="manage-ngsild-upload-heading" class="manage-file-upload-modal__title">Connection Details</h2>
              <p id="manage-ngsild-upload-desc" class="manage-file-upload-modal__lede">
                @switch (getNgsildUploadModalConnectionDetailsLedeKind()) {
                  @case ('data-source-readonly') {
                    View the <strong>Data Source URL</strong> connected to this asset.
                  }
                  @case ('file-server') {
                    @if (getNgsildUploadModalDataSourceUrlEnabled()) {
                      Upload files directly or connect a <strong>Data Source URL</strong> to fetch data automatically.
                    } @else {
                      Upload files directly to add data to this dataset.
                    }
                  }
                  @case ('gateway') {
                    @if (getNgsildUploadModalDataSourceUrlEnabled()) {
                      Configure <strong>SFTP</strong> or <strong>API</strong> connection details, set up
                      <strong>Direct Push</strong>, or connect a <strong>Data Source URL</strong> to fetch data automatically.
                    } @else {
                      Configure <strong>SFTP</strong> or <strong>API</strong> connection details, or set up
                      <strong>Direct Push</strong>.
                    }
                  }
                  @case ('direct-push') {
                    View your <strong>Direct Push</strong> configuration and use the Python script to push data to this dataset.
                  }
                  @default {
                    @if (getNgsildUploadModalDataSourceUrlEnabled()) {
                      Configure <strong>SFTP</strong> or <strong>API</strong> connection details, or connect a
                      <strong>Data Source URL</strong> to fetch data automatically.
                    } @else {
                      Configure <strong>SFTP</strong> or <strong>API</strong> connection details.
                    }
                  }
                }
              </p>
              <p class="manage-file-upload-modal__subtitle" *ngIf="ngsildUploadModalRow?.assetName">
                {{ getManageAssetsAssetKindLabel(ngsildUploadModalRow) }}: <strong>{{ ngsildUploadModalRow.assetName }}</strong>
              </p>
            </div>
            <button
              type="button"
              class="manage-file-upload-modal__close"
              (click)="closeNgsildUploadModal(); $event.stopPropagation()"
              aria-label="Close connection details dialog"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </header>
          <div class="manage-file-upload-modal__body manage-file-upload-modal__body--ngsild-upload">
            <lib-ngsild-upload-files
              layout="modal"
              [showModalPreviousButton]="false"
              [resourceServer]="getNgsildUploadModalResourceServer()"
              [fileFormat]="getNgsildUploadModalFileFormat()"
              [itemId]="getNgsildUploadModalItemId()"
              [assetKind]="ngsildUploadModalRow && isModelAsset(ngsildUploadModalRow) ? 'model' : 'dataset'"
              [onboardingPayload]="getNgsildOnboardingPayloadForUploadModal()"
              [lockedUploadMethod]="getNgsildUploadModalLockedMethod()"
              [lockedModalMode]="getNgsildUploadModalLockedModalMode()"
              [existingMediaUrl]="getNgsildUploadModalMediaUrl()"
              [existingAssetRequestType]="getNgsildExistingAssetRequestType()"
              (modalDismiss)="closeNgsildUploadModal()"
              (publishSuccess)="onNgsildUploadModalPublishSuccess()"
              (uploadRequestSuccess)="onNgsildUploadModalRequestSuccess($event)"
              (directPushSuccess)="onNgsildUploadModalDirectPushSuccess()"
            />
          </div>
        </div>
      </div>

      <lib-additional-info-modal
        *ngIf="showAdditionalInfoModal && additionalInfoModalRow && getAdditionalInfoModalAssetId()"
        [assetId]="getAdditionalInfoModalAssetId()"
        [assetLabel]="additionalInfoModalRow.assetName"
        [assetKindLabel]="getManageAssetsAssetKindLabel(additionalInfoModalRow)"
        [preloadedItems]="getAdditionalInfoModalPreloaded()"
        (closed)="closeAdditionalInfoModal()"
        (saved)="onAdditionalInfoSaved($event)"
      />

      <!-- SFTP / API submit success — confirmation after asset/request (org admin + platform admin for providers). -->
      <div
        *ngIf="ngsildUploadRequestSuccessVisible"
        class="onboarding-success-modal onboarding-upload-request-success-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="manage-ngsild-upload-request-success-title"
        aria-describedby="manage-ngsild-upload-request-success-desc"
        (keydown)="$event.stopPropagation()"
      >
        <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
        <div class="onboarding-success-modal__panel">
          <div class="onboarding-success-modal__body">
            <div class="onboarding-publish-success-modal__icon" aria-hidden="true">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#16a34a" stroke-width="2" />
                <path d="M9 12l2 2 4-4" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h2 id="manage-ngsild-upload-request-success-title" class="onboarding-success-modal__title">
              {{ getNgsildUploadRequestSuccessTitle() }}
            </h2>
            <p id="manage-ngsild-upload-request-success-desc" class="onboarding-publish-success-modal__message">
              {{ getNgsildUploadRequestSuccessMessage() }}
            </p>
            <div class="onboarding-upload-request-success-modal__next-steps">
              <p class="onboarding-upload-request-success-modal__next-steps-title">What happens next?</p>
              <p class="onboarding-upload-request-success-modal__next-steps-body">
                {{ getNgsildUploadRequestSuccessNextSteps() }}
              </p>
            </div>
            <div class="onboarding-success-modal__actions onboarding-success-modal__actions--row">
              <button
                type="button"
                class="onboarding-success-modal__btn onboarding-success-modal__btn--secondary"
                (click)="closeNgsildUploadRequestSuccessModal()"
              >
                Close
              </button>
              <button
                type="button"
                class="onboarding-success-modal__btn onboarding-success-modal__btn--primary"
                [disabled]="!getNgsildUploadRequestSuccessAssetId()"
                (click)="onNgsildUploadRequestSuccessViewDataset()"
              >
                View Dataset
              </button>
            </div>
          </div>
          <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
            <img src="/assets-leaf.png" alt="" class="onboarding-success-modal__leaf-image" />
          </div>
        </div>
      </div>

      <app-modal
        [(visible)]="showViewFeedbackModal"
        [header]="feedbackDetailsTitle"
        styleClass="custom-modal view-feedback-dialog"
        [width]="'820px'"
        [showFooter]="false"
        (onClose)="closeViewFeedbackModal()"
      >
        <div class="view-feedback-modal">
          <section
            class="view-feedback-modal__summary"
            *ngIf="!viewFeedbackLoading && !viewFeedbackError && viewFeedbackSummary"
            [attr.aria-label]="'Overall rating ' + (viewFeedbackSummary.averageRating ?? 0) + ' out of 5'"
          >
            <div class="view-feedback-modal__summary-leaf" aria-hidden="true">
              <img src="/assets-leaf.png" alt="" class="view-feedback-modal__summary-leaf-image" />
            </div>
            <div class="view-feedback-modal__summary-main">
              <span class="view-feedback-modal__summary-label">Overall rating</span>
              <div class="view-feedback-modal__summary-score">
                <span class="view-feedback-modal__summary-value">
                  {{ viewFeedbackSummary.averageRating != null ? (viewFeedbackSummary.averageRating | number:'1.1-1') : '—' }}
                </span>
                <div class="view-feedback-modal__summary-stars" aria-hidden="true">
                  <span class="view-feedback-modal__summary-star" *ngFor="let star of [1, 2, 3, 4, 5]">
                    <img src="icons/dataset-ratings/star-outline.svg" alt="" width="18" height="18" />
                    <span class="view-feedback-modal__summary-star-fill" [style.width.%]="summaryStarFillPercent(star)">
                      <img src="icons/dataset-ratings/star-filled.svg" alt="" width="18" height="18" />
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <span class="view-feedback-modal__summary-count">
              {{ viewFeedbackSummary.totalRatings }}
              {{ viewFeedbackSummary.totalRatings === 1 ? 'rating' : 'ratings' }}
            </span>
          </section>
          <div *ngIf="viewFeedbackLoading" class="loading-container">
            <p>Loading feedback...</p>
          </div>
          <p *ngIf="!viewFeedbackLoading && viewFeedbackError" class="view-feedback-modal__error">
            {{ viewFeedbackError }}
          </p>
          <p *ngIf="!viewFeedbackLoading && !viewFeedbackError && viewFeedbackRows.length === 0" class="view-feedback-modal__empty">
            No feedback yet for this asset.
          </p>
          <div *ngIf="!viewFeedbackLoading && viewFeedbackRows.length > 0" class="view-feedback-modal__list">
            <article class="view-feedback-card" *ngFor="let row of viewFeedbackRows">
              <div class="view-feedback-card__top">
                <div class="view-feedback-card__stars" [attr.aria-label]="'Rating ' + row.rating + ' out of 5'">
                  <img
                    *ngFor="let star of [1, 2, 3, 4, 5]"
                    [src]="feedbackStarFilled(row.ratingValue, star) ? 'icons/dataset-ratings/star-filled.svg' : 'icons/dataset-ratings/star-outline.svg'"
                    alt=""
                    width="18"
                    height="18"
                  />
                </div>
                <time class="view-feedback-card__date">{{ row.createdAt }}</time>
              </div>
              <p class="view-feedback-card__name">{{ row.consumerName }}</p>
              <p class="view-feedback-card__email" *ngIf="row.consumerEmail && row.consumerEmail !== 'N/A' && row.consumerEmail !== row.consumerName">
                {{ row.consumerEmail }}
              </p>
              <p class="view-feedback-card__org" *ngIf="row.organisation && row.organisation !== 'N/A'">{{ row.organisation }}</p>
              <p class="view-feedback-card__comment" [class.view-feedback-card__comment--empty]="row.userFeedback === 'No written feedback'">
                {{ row.userFeedback }}
              </p>
            </article>
          </div>
        </div>
      </app-modal>

      <!-- Modify Asset Modal (same as Access Request page) -->
      <app-modal
        [(visible)]="showModifyModal"
        header="Modify Asset Metadata"
        [width]="'900px'"
        [showFooter]="false"
        (onCancel)="closeModifyModal()"
      >
        <div *ngIf="isLoadingAssetData" class="loading-container">
          <p>Loading asset data...</p>
        </div>
        <app-provider-preview-metadata
          *ngIf="!isLoadingAssetData && modifyAssetData && modifyFormInstanceKey"
          [editableMode]="true"
          [allowSaveWithoutDirty]="true"
          [assetData]="modifyAssetData"
          [assetType]="getAssetTypeForModify()"
          (formSubmit)="onModifyFormSubmit($event)"
          (formCancel)="onModifyFormCancel()"
        ></app-provider-preview-metadata>
      </app-modal>

      <!-- View Files: delete file (same confirmation pattern as profile Delete Account) -->
      <app-confirmation-dialog
        [visible]="showViewFilesDeleteConfirmDialog"
        (visibleChange)="onViewFilesDeleteDialogVisibleChange($event)"
        type="delete"
        themeColor="red"
        title="Delete File"
        [message]="getViewFilesDeleteConfirmMessage()"
        confirmLabel="Delete"
        cancelLabel="Cancel"
        [loading]="viewFilesDeleteLoading"
        [baseZIndex]="12600"
        (onConfirm)="onConfirmDeleteViewFilesFile()"
        (onCancel)="onCancelViewFilesDeleteDialog()"
      ></app-confirmation-dialog>
    </div>
  </div>
</div>


